import {GetVehiclesResponse} from "@handover/http-services/responses/get-vehicles.response";
import {VehicleListItem} from "@handover/view-models/vehicle-list-item";

export class GetVehicleResponseMapper {
  mapToVehicleListItem(responses: GetVehiclesResponse[]): VehicleListItem[] {
    const models: VehicleListItem[] = [];

    for (let vehicle of responses) {
      const model = {} as VehicleListItem;
      model.vehicleId = vehicle.ID;
      model.isAvailable = vehicle.DR == null;
      if (vehicle.DR) {
        model.driverId = vehicle.DR.ID;
      }
      models.push(model);
    }

    return models.sort((a, b) => Number(b.isAvailable) - Number(a.isAvailable));
  }
}
